<template>
  <div class="col-5 p-0 d-flex justify-content-end">
    <div>
      <b-button class="w-100" variant="success" size="md" :disabled="!enableContinueButton" @click="create">
        Continue
      </b-button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { CREATE_PACKING_SLIP, PACKING_SLIP } from '@/const/ModalTypes'
import { READY, FAILED, GENERATING } from '@/const/PackingSlipEventTypes'
import { openModal } from '@/services/Modal'
import { useAccountStore } from '@/store/account'
import { usePackingSlipStore } from '@/store/packingSlip'
import { useVueNextModalStore } from '@/store/vueNextModal'

export default defineComponent({
  name: 'Continue',
  props: {
    enableContinueButton: {
      type: Boolean,
      default: false,
    },
    fromPreviousPackingSlip: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const accountStore = useAccountStore()
    const modalStore = useVueNextModalStore()
    const packingSlipStore = usePackingSlipStore()

    const create = () => (props.fromPreviousPackingSlip ? createPackingSlipFromPackingSlipItems() : createPackingSlip())

    const createPackingSlipFromPackingSlipItems = () => {
      openModal('confirmWrap', {
        title: 'Create Packing Slip',
        message:
          'You are trying to create a packing slip with items that are already in other packing slips,' +
          'if you continue items will be removed from selected packing slips and files will be re-generated.' +
          'Are you sure you want to continue?',
        onConfirm: createPackingSlip,
      })
    }

    const listenToPackingSlipEvents = (packingSlip: any) => {
      const stopListeningToPackingSlipEvents = () => {
        window.Echo.channel(`App.User.${accountStore.userId}`)
          .stopListening(`.${packingSlip.id}.${GENERATING}`)
          .stopListening(`.${packingSlip.id}.${READY}`)
          .stopListening(`.${packingSlip.id}.${FAILED}`)
      }
      window.Echo.channel(`App.User.${accountStore.userId}`)
        .listen(`.${packingSlip.id}.${GENERATING}`, (data: any) => {
          packingSlipStore.setPackingSlip(data)
        })
        .listen(`.${packingSlip.id}.${READY}`, (data: any) => {
          packingSlipStore.setPackingSlip(data)
          packingSlipStore.getPackingSlips()
          stopListeningToPackingSlipEvents()
        })
        .listen(`.${packingSlip.id}.${FAILED}`, (data: any) => {
          packingSlipStore.setPackingSlip(data)
          stopListeningToPackingSlipEvents()
        })
    }

    const createPackingSlip = () => {
      const data: any = {}
      if (packingSlipStore.checkedItems.length > 0) {
        data.items = packingSlipStore.checkedItems
      } else {
        data.assignments = packingSlipStore.checkedAssignments
      }
      if (accountStore.isStaff) {
        data.companyId = packingSlipStore.companyId
      }
      packingSlipStore.create(data).then(() => {
        listenToPackingSlipEvents(packingSlipStore.packingSlip)
      })
      modalStore.closeModal(CREATE_PACKING_SLIP)
      openModal(PACKING_SLIP)
    }

    return {
      create,
      createPackingSlip,
      createPackingSlipFromPackingSlipItems,
    }
  },
})
</script>
